import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import DraggableModal from '../../../components/commonAction/DraggableModal';

function FilterDeleteModal(props) {
    const handlePatientDeleteOperation = (state, property) => {
        props.handleRemoveFilterConfirm(state, property);
    };

    const handleCloseOperation = () => {
        props.updateState({
            deleteQuery: false,
        });
    };
    return (
        <>
            <DraggableModal
                show={props.deleteQuery}
                onHide={handleCloseOperation}
                animation={false}
                size='lg'
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header
                    closeButton
                    className='modal-header d-block justify-content-start'
                >
                    <Modal.Title className='d-flex align-items-stretch justify-content-between'>
                        <div className=''>
                            <i
                                title='Delete'
                                className='fas fa-trash-alt mr-3'
                            />
                            Remove Filter
                        </div>
                        <i
                            title='Close'
                            className='fa-light fa-xmark d-flex justify-content-end align-items-center'
                            aria-hidden='true'
                            onClick={handleCloseOperation}
                        />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='deletes'>
                    <h6>
                        Are you sure you want to remove "
                        {props.stateRemoveFilter}" filter?
                    </h6>
                </Modal.Body>
                <Modal.Footer className='d-block delete_btn'>
                    <div className='d-flex footer-btn align-items-stretch justify-content-between'>
                        <div className='d-flex'>
                            <Button
                                variant='secondary'
                                onClick={handleCloseOperation}
                                title='Cancel'
                            >
                                Cancel
                            </Button>
                        </div>
                        <div className='d-flex'>
                            <Button
                                className='danger'
                                onClick={() =>
                                    handlePatientDeleteOperation(
                                        props.stateRemoveFilter,
                                        props.propertyRemoveFilter
                                    )
                                }
                                title='Yes, Delete'
                            >
                                Yes, Delete
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </DraggableModal>
        </>
    );
}
export default FilterDeleteModal;
